import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { UserInterface } from "../../../interfaces/userInterface";

type UserTableProps = {
  data: UserInterface[];
  isLoading: boolean;
  roleNameById: Record<string, string>;
} & Pick<
  DataTableProps<UserInterface>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<UserInterface>[] = [
  { key: "name", label: "Nombre" },
  { key: "lastName", label: "Apellido" },
  { key: "userName", label: "Nombre de usuario" },
  { key: "roleId", label: "Rol" },
  { key: "active", label: "Activo", isBoolean: true },
];

export const UserTable = (props: UserTableProps) => {
  const { isLoading, roleNameById, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="user-table"
      customRender={(key, item) => {
        if (key === "roleId") {
          return roleNameById[item.roleId] ?? item.roleId;
        }
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
